import { render, staticRenderFns } from "./list_item_stat.vue.js?vue&type=template&id=455f3b31&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=template&id=455f3b31&vue3"
import script from "./list_item_stat.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=script&lang=js&vue3"
export * from "./list_item_stat.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list_item_stat.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports